import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PastProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  toggleShowMore() {
    const { expanded } = this.state;

    this.setState({ expanded: !expanded });
  }

  renderSeeMore() {
    const { expanded } = this.state;

    return (
      <a
        className="body-text-2 expand-projects mt-2"
        onClick={this.toggleShowMore}
        role="link"
        tabIndex={0}
      >
        { expanded ? 'See Less' : 'View all projects' }
      </a>
    );
  }

  render() {
    const { projects } = this.props;
    const { expanded } = this.state;
    const visibleProjects = expanded ? projects : projects.slice(0, 3);

    return (
      <div className="past-projects" id="past-projects">
        <div className="past-projects-overview">
          <div className="g-row--always header">
            <h2>Past Projects on Clora</h2>
          </div>
        </div>
        <div>
          {visibleProjects.map((project) => (
            <div className="project" key={project.id}>
              <div className="mb-12">
                <h3 className="project-name">{project.name}</h3>
                <p className="body-text-2">{project.company}</p>
              </div>
            </div>
          ))}
          {projects.length > 3 ? this.renderSeeMore() : ''}
        </div>
      </div>
    );
  }
}

PastProjects.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default PastProjects;
